// extracted by mini-css-extract-plugin
export default {"legendaMapa":"Legenda_legendaMapa__Lk1L8","item":"Legenda_item__BXPme","blocoCor":"Legenda_blocoCor__pddeT"};